import $ from 'jquery';
import DDTemplates from 'dd-templates';

import Drupal from './Drupal';
import Header from './Header';
import Footer from './Footer';
import Menu from './Menu';
import MenuCtrl from './MenuCtrl';
import TermNavigation from './TermNavigation';
import Toolbar from './Toolbar';
import Gallery from './Gallery';
import CalendarFeed from './CalendarFeed';
import HeroCarousel from './HeroCarousel';
import GallerySlider from './GallerySlider';
import FeaturedSlider from './FeaturedSlider';
import PlaceholderText from './PlaceholderText';
import Notify from './Notify';

// Add the theme behaviors

Drupal.behavior((context) => {
  // Helpers

  const $body = $(document.body, context);
  const $footer = $('.page-footer', context);
  const $footprint = $('.footprint', context);

  // DD Template Behaviors

  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Fix our damn menus from displaying orphaned children

  $('.primary-navigation, .term-nav', context).each((i, element) => {
    $('.menuparent, .expanded, .collapsed', element).each((j, item) => {
      // handles the parent term (if hidden)
      const $parent = $(item).children('a');
      if (!$parent.length || $parent.is('.hidden')) {
        $(item).remove();
      }
      // handles the term to see if it only parents orphans.
      const $children = $('> ul > li', item);
      if (!$parent.is('.hidden') && $children.length) {
        const $orphans = $children.children('a.hidden');
        $orphans.parent().remove();
        if ($orphans.length === $children.length) {
          $(item).removeClass('expanded menuparent collapsed');
          $(item).children('ul').remove();
        }
      }
    });
  });

  // Add placeholder text to all webform textfield components

  $('.node-webform .type-textfield', context).each((i, element) => {
    if (!element.placeholderText) {
      element.placeholderText = new PlaceholderText(element);
    }
  });

  // Main/Primary Site Navigation

  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.menu) {
      const breakpoint = 1024;
      element.menu = new Menu(element, { breakpoint });
      element.menuCtrl = new MenuCtrl(element, { breakpoint });
    }
  });

  // Controls the states of the menu and search states

  $('.site-toolbar', context).each((i, element) => {
    if (!element.toolbar) {
      element.toolbar = new Toolbar(element, context);
    }
  });

  // Controller for the infinite campus utility link

  $('.infinite-campus button', context).bind('click', (event) => {
    $(event.currentTarget).next('.campus-options').toggleClass('expand');
  });

  // Controls the page overlay display

  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js

  $('.headroom', context).each((i, element) => {
    if (!element.headroom) {
      element.headroom = new Header(element);
    }
  });

  // Smart Footer

  $footer.each((i, footer) => {
    if (!footer.smartFooter && $footprint.length) {
      footer.smartFooter = new Footer(footer, $footprint);
    }
  });

  // Footer background

  $('#block-views_blocks-term-block_1-16', context).each((i, element) => {
    const $nodes = $(element).find('.node');
    const $top = $footer.find('.footer-top');

    // Add footer background graphic.
    if ($top.length) {
      const src = $nodes.eq(0).find('.field-image.c1 img').attr('src');
      if (src && src.length) {
        $top.css('background-image', `url(${src})`);
      }
    }

    // Create accordion functionality from headers and content.
    $nodes.each((a, node) => {
      $(node).find('.node-header a').bind('click', (event) => {
        event.preventDefault();
        $nodes.not(node).filter('.expand').removeClass('expand');
        $(node).toggleClass('expand');
      });
    });
  });

  // Term Navigation

  $('.term-nav', context).each((i, element) => {
    if (!element.termNavigation) {
      element.termNavigation = new TermNavigation(element);
    }
  });

  // Homepage Hero Carousel

  $('#block-views_blocks-term-block_1-1', context).each((i, element) => {
    if (!element.heroCarousel) {
      element.heroCarousel = new HeroCarousel(element);
    }
  });

  // Homepage Featured Slider

  $('#block-views_blocks-term-block_1-8', context).each((i, element) => {
    if (!element.featuredSlider) {
      element.featuredSlider = new FeaturedSlider(element);
    }
  });

  // Homepage Photo Gallery Slider

  $('#block-views_blocks-term-block_1-13', context).each((i, element) => {
    if (!element.gallerySlider) {
      element.gallerySlider = new GallerySlider(element);
    }
  });

  // Homepage Trifecta Accordions

  $('.trifecta .block-title', context).bind('click', (event) => {
    $(event.currentTarget).parents('.block').toggleClass('expand');
  });

  // Photo Galleries

  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.gallery) {
      element.gallery = new Gallery(element);
    }
  });

  // Calendar of Events View

  $('.calendar-feed', context).each((i, element) => {
    if (!element.calendarFeed) {
      element.calendarFeed = new CalendarFeed(element);
    }
  });

  // Notifications

  $('#block-views_blocks-term-block_1-18', context).each((i, element) => {
    if (!element.notifications && $(element).find('.node').length) {
      element.notifications = new Notify(element);
    }
  });

  // Add Sitemap output using the digitaldcore.js function

  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});



// WEBPACK FOOTER //
// ./theme.js